// eslint-disable-next-line no-shadow
export enum MeasureMutationTypes {
  SET_MEASURES_OVERVIEW = "SET_MEASURES_OVERVIEW",
  SET_MEASURE_DETAIL = "SET_MEASURE_DETAIL",
  SET_PAGINATION_DATA = "SET_PAGINATION_DATA",
  SET_SEARCH_VALUE = "SET_SEARCH_VALUE",
}
